// ---------------------------------------------------------------------
// Foundation Tools Sidebar and Footer
// Requires functions defined in tabs.js
// ---------------------------------------------------------------------

/**
 * Foundation tools sidebars and header/footers. Requires tabs.js stuff.
 * @constructor
 * @param {ElementUnion} elem
 * @param {Object=} options
 */
Foundation.Tools = function (elem, options) {
    this.elem = $(elem);
    this.options = {
        "orientation": "vertical"
    };
    Foundation.extend(this.options, options);

    var panels = this.elem.select("div.togglePanel");
    var activators = this.elem.select("a.toggleActivator");
    var toggles = dnSetupToggleGroupAnimated(activators, panels);

    // Horizontal tools chicanery
    if (this.options["orientation"] === "horizontal") {
        panels.each(function (panel) {
            panel.addClassName("horizontalToolsTogglePanel");
            panel.remove();
            $(document.body).insert(panel);
            panel.absolutize();

            var toggle = toggles.getElementFromMap(panel);
            var pos = toggle.up().cumulativeOffset();
            pos[1] += toggle.up().getHeight();
            panel.setStyle({ "left": `${pos[0]}px`, "top": `${pos[1]}px` });
        });
    }

    // Setup ajax request and related animations for the panels.
    panels.invoke("observe", "dnPanel:afterShow", function () {
        var panel = $(this);
        var updaterDiv = panel.down(".ajaxUpdater");
        if (updaterDiv) new Ajax.Updater(updaterDiv, "/gyrobase/Macros/ToolsAjax", {
            "parameters": {
                "macro": panel.readAttribute("data-toolsajaxmacro"),
                "object": panel.readAttribute("data-toolsoid"),
                "url": window.location
            },
            "onComplete": function () {
                panel.down(".loading").blindUp({ "duration": 0.3 });
                if (updaterDiv) updaterDiv.blindDown({ "duration": 0.3 });
            }
        });
    });
    panels.invoke("observe", "dnPanel:afterHide", function () {
        var loading = $(this).down(".loading");
        if (loading) loading.show();

        var updater = $(this).down(".ajaxUpdater");
        if (updater) updater.hide();
    });
};

Foundation.Tools.addToList = function (formid) {
    var listPanel = $(formid).up("div.togglePanel");
    listPanel.down(".loading").blindDown({ "duration": 0.3 });
    listPanel.down(".ajaxUpdater").blindUp({
        "duration": 0.3,
        "afterFinish": function () {
            $(formid).request({ "onComplete": function (t) {
                  listPanel.down(".ajaxUpdater").update(t.responseText);
                  listPanel.down(".loading").blindUp({ "duration": 0.3 });
                  listPanel.down(".ajaxUpdater").blindDown({ "duration": 0.3 });
            }});
        }
    });
};

Foundation.Tools.remindMe = function (formid) {
    var rmPanel = $(formid).up("div.togglePanel");
    rmPanel.down(".loading").blindDown({ "duration": 0.3 });
    rmPanel.down(".ajaxUpdater").blindUp({
        "duration": 0.3,
        "afterFinish": function () {
            $(formid).request({ "onComplete": function (t) {
                  rmPanel.down(".ajaxUpdater").update(t.responseText);
                  rmPanel.down(".loading").blindUp({ "duration": 0.3 });
                  rmPanel.down(".ajaxUpdater").blindDown({ "duration": 0.3 });
            }});
        }
    });
};

// Toggle Custom Reminder Times
Foundation.Tools.showCustomRemindTime = function (oid) {
    if ($F(`remindRelative${oid}`) == 'other') {
        $(`customRemindTime${oid}`).show();
    }
    else {
        $(`customRemindTime${oid}`).hide();
    }
};

Foundation.Tools.setup = function () {
    if (Foundation.Tools.setup.alreadyRan) return;
    Foundation.Tools.setup.alreadyRan = true;

    Foundation.documentReady.then(function () {
        $$("div.tools", "div.tinyTools").each(function (elem) {
            new Foundation.Tools(elem);
        });
        $$("div.horizontalTools").each(function (elem) {
            new Foundation.Tools(elem, { "orientation": "vertical" });
        });
    });
};

// ---------------------------------------------------------------------

window["Foundation"]["Tools"] = Foundation.Tools;
window["Foundation"]["Tools"]["addToList"] = Foundation.Tools.addToList;
window["Foundation"]["Tools"]["remindMe"] = Foundation.Tools.remindMe;
window["Foundation"]["Tools"]["showCustomRemindTime"] = Foundation.Tools.showCustomRemindTime;
window["Foundation"]["Tools"]["setup"] = Foundation.Tools.setup;

// ---------------------------------------------------------------------

/* eslint eqeqeq: "off" */
